import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=09d7e33a&scoped=true&"
import script from "./RequestAccess.vue?vue&type=script&lang=js&"
export * from "./RequestAccess.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=09d7e33a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7e33a",
  null
  
)

export default component.exports